import { Component, OnInit } from '@angular/core';
import { SCopyCaseEntryService } from '../pages/copy-case/copy-case-entry/s-copy-case-entry.service';

@Component({
  selector: 'app-print-case-annex-iv-report',
  templateUrl: './print-case-annex-iv-report.component.html',
  styleUrls: ['./print-case-annex-iv-report.component.scss']
})
export class PrintCaseAnnexIVReportComponent implements OnInit {

  breadCrumbItems: Array<{}> = [];

  constructor(public objSCopyCaseEntryService: SCopyCaseEntryService) { }

  ngOnInit(): void {
    this.objSCopyCaseEntryService.getCopyCasesIVAssign()
  }
}
